import { render, staticRenderFns } from "./press-logos-tablet.vue?vue&type=template&id=c74df43c&scoped=true&lang=pug&"
var script = {}
import style0 from "./press-logos-tablet.vue?vue&type=style&index=0&id=c74df43c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74df43c",
  null
  
)

export default component.exports